
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0.647278C6.12297 0.647278 2.96875 3.83109 2.96875 7.74449C2.96875 9.0667 3.3316 10.357 4.01832 11.4765L9.59977 20.5553C9.70668 20.7292 9.89504 20.8349 10.0976 20.8349C10.0992 20.8349 10.1007 20.8349 10.1023 20.8349C10.3066 20.8333 10.4954 20.7243 10.6003 20.5474L16.0395 11.3806C16.6883 10.2848 17.0312 9.02746 17.0312 7.74449C17.0312 3.83109 13.877 0.647278 10 0.647278ZM15.0338 10.7733L10.0887 19.1074L5.01434 10.8533C4.44273 9.92152 4.13281 8.84653 4.13281 7.74449C4.13281 4.48332 6.76914 1.82226 10 1.82226C13.2309 1.82226 15.8633 4.48332 15.8633 7.74449C15.8633 8.81384 15.5738 9.86135 15.0338 10.7733Z"}}),_c('path',{attrs:{"d":"M10 4.19588C8.06148 4.19588 6.48438 5.78778 6.48438 7.74448C6.48438 9.68869 8.03582 11.2931 10 11.2931C11.9884 11.2931 13.5156 9.66732 13.5156 7.74448C13.5156 5.78778 11.9385 4.19588 10 4.19588ZM10 10.1181C8.7009 10.1181 7.64844 9.05222 7.64844 7.74448C7.64844 6.44002 8.70766 5.37086 10 5.37086C11.2923 5.37086 12.3477 6.44002 12.3477 7.74448C12.3477 9.03314 11.3197 10.1181 10 10.1181Z"}})])
          )
        }
      }
    